import { render, staticRenderFns } from "./TestAPISideBar.vue?vue&type=template&id=4be13b74"
import script from "./TestAPISideBar.vue?vue&type=script&lang=js"
export * from "./TestAPISideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports